/**
 * Set cookie on the singtel.com domain
 *
 * We have a simple implementation because @lux/helper's setCookie
 * doesnt let us set the path. Once that is solved, we will use that
 * one instead.
 *
 * @param {*} name Name of cookie
 * @param {*} value Value of cookie
 */
const setCookie = (name: string, value: string) => {
  document.cookie = name + '=' + value + '; path=/;domain=.singtel.com';
};

export default setCookie;
